import {useCallback, useEffect, useMemo, useState} from 'react';
import {listLicencas} from './LicencasService';
import {buildLicencaStats, extractListPayload, getBackendMessage, normalizeLicencaRows} from './licencasUtils';

export function useLicencas() {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadLicencas = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const response = await listLicencas({
                page: 1,
                pageSize: 100,
                sortBy: 'atualizado_em',
                order: 'desc',
            });
            setRows(normalizeLicencaRows(extractListPayload(response).items));
        } catch (loadError) {
            setRows([]);
            setError(getBackendMessage(loadError, 'Não foi possível carregar as licenças.'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadLicencas();
    }, [loadLicencas]);

    const stats = useMemo(() => buildLicencaStats(rows), [rows]);

    return {
        rows,
        stats,
        loading,
        error,
        reload: loadLicencas,
    };
}
